import React from "react";
import { Input  } from 'antd';

function KoSubDomain(props) {
  return (
    <Input
      addonBefore="https://" addonAfter="kwapio.com"
      {...props}
      style={{ width: '100%' }}
    />
  );
}

export default KoSubDomain;